import { Map, List } from 'immutable'
import {
  CONTENT_TYPE_SERIES,
  CONTENT_TYPE_VIDEO,
} from 'services/content/content-types'

export default Map({
  [CONTENT_TYPE_SERIES]: List([
    Map({ label: 'Please select a product type', value: '' }),
    Map({ label: 'Episodic', value: 'episodic' }),
    Map({ label: 'Segmented', value: 'segmented' }),
  ]),
  [CONTENT_TYPE_VIDEO]: List([
    Map({ label: 'Please select a product type', value: '' }),
    Map({ label: 'Episode', value: 'episode' }),
    Map({ label: 'Segment', value: 'segment' }),
    Map({ label: 'Single', value: 'single' }),
  ]),
})
